import { Grid, Paper } from "@mui/material"
import { Title } from "components/Common/Title"
import { CreateLessonDialog } from "components/TrainingContent/Lesson/CreateLessonDialog"
import { LessonList } from "components/TrainingContent/Lesson/LessonList"
import { useAppDispatch, useAppSelector } from "hooks"
import { useEffect } from "react"
import { useParams } from "react-router-dom"
import chapterService from "services/chapterService"
import { setCurrentChapter } from "slices/chapterSlice"

export function Chapter() {
  const currentChapter = useAppSelector((state) => state.chapter.currentChapter)
  const { id } = useParams()
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (currentChapter !== undefined) {
      return
    }

    if (id === undefined) {
      return
    }

    chapterService
      .getChapter(id)
      .then((chapter) => {
        dispatch(setCurrentChapter(chapter))
      })
      .catch((err) => {
        console.log(err)
      })
  }, [currentChapter, dispatch, id])

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Grid container paddingBottom={2}>
            <Grid item xs>
              <Title>{currentChapter?.name}</Title>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Grid container paddingBottom={2}>
            <Grid item xs>
              <Title>LESSONS</Title>
            </Grid>
            <Grid item>
              <CreateLessonDialog />
            </Grid>
          </Grid>
          {currentChapter && <LessonList chapter={currentChapter} />}
        </Paper>
      </Grid>
    </Grid>
  )
}
